import { render, staticRenderFns } from "./InvoiceFilesViewer.vue?vue&type=template&id=286a2108&"
import script from "./InvoiceFilesViewer.vue?vue&type=script&lang=js&"
export * from "./InvoiceFilesViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports